export const InputRegexPatterns = {
  GERMAN_POSTCODE: '[0-9]{5}',
  PHONE_NUMBER: '^[ +0-9-_.()/s]{6,}$',
  // TODO: Change to German IBAN
  IBAN: '[a-zA-Z]{2}\\d{2}\\s?([0-9a-zA-Z]{4}\\s?){4}[0-9a-zA-Z]{2}',
  // prettier-ignore
  PASSWORD: "^(?=\\S*[a-zäöü])(?=\\S*[A-ZÄÖÜ])(?=\\S*\\d)(?=\\S*[#$^+=!*()\\{\\}\[\\]@%&§\"\'´`_,.\\-])\\S{8,}$",
  PASSWORD_JS: /^(?=\S*[a-zäöü])(?=\S*[A-ZÄÖÜ])(?=\S*\d)(?=\S*[#$^+=!*()\{\}\[\]@%&§\"\'´`_,.\\-])\S{8,}$/,
  DATE: /^\d{4}-\d{2}-\d{2}$/,
};
